<template>
  <div>
    <div class="attendance-table-container">
      <el-table
          :data="items"
          v-loading="loading"
          border
          class="sk-table custom-attendance-table"
          style="width: 100%"
          :max-height="$tableMaxHeight"
          @selection-change="handleSelectionChange"
      >
        <el-table-column
            type="selection"
            width="50"
            align="center"
            fixed="left"
        />

        <el-table-column type="index" label="STT" width="55" align="center" fixed="left"/>

        <el-table-column label="Học sinh" prop="nameStudent" min-width="200" fixed="left">
          <template #default="{ row }">
            <div class="student-profile-cell">
              <span class="student-name-text">{{ row.nameStudent || "" }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Trạng thái" width="130" align="center" fixed="left">
          <template #default="{ row }">
            <div class="status-cell">
      <span :class="['status-badge', `status-badge--${row.status.toLowerCase()}`]">
        {{ getStatus(row) }}
      </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Lớp" width="120" align="center">
          <template #default="{ row }">
            <div class="status-cell">
              {{ row.className || "" }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Ngày tạo" width="150" align="center">
          <template #default="{ row }">
            <div class="status-cell">
              {{ row.createdDate | formatDateTime }}
            </div>
          </template>
        </el-table-column>

        <!-- Khối thời gian -->
        <el-table-column label="Xử lý" width="200" align="center">
          <template #default="{ row }">
            <div class="status-cell">
              {{ row.nameConfirm }}
              <br>
              {{ row.confirmDate | formatDateTime }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Nội dung" width="300">
          <template #default="{ row }">
            <div class="content-wrapper">
              <div :class="['content-text', { 'is-collapsed': !expandedRows.includes(row.id || row.nameStudent) }]">
                {{ row.content }}
              </div>
              <span
                  v-if="row.content && row.content.length > 150"
                  class="toggle-content-btn"
                  @click="toggleExpand(row)"
              >
        {{ expandedRows.includes(row.id || row.nameStudent) ? 'Rút gọn' : 'Xem thêm' }}
      </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Ngày nghỉ" width="200" align="center">
          <template #default="{ row }">
            {{ row.fromDate | formatDate }} - {{ row.toDate | formatDate }}
          </template>
        </el-table-column>

        <el-table-column label="Số lượng ảnh" width="95" align="center">
          <template #default="{ row }">
            {{ row.attachments.length }}
          </template>
        </el-table-column>

        <!-- Cột tác vụ hành động -->
        <el-table-column label="Tác vụ" align="center" width="200" fixed="right">
          <template #default="{ row }">
            <div class="action-buttons-wrapper">
              <el-button
                  type="success"
                  class="row-action-btn btn-edit"
                  :disabled="row.status !== 'PENDING'"
                  @click.stop="handleApproved(row)"
              >Duyệt
              </el-button>
              <el-button
                  type="danger"
                  class="row-action-btn btn-cancel"
                  :disabled="row.status === 'APPROVED'"
                  @click.stop="handleDelete(row)"
              >Xoá
              </el-button>
              <el-button
                  type="primary"
                  class="row-action-btn btn-save"
                  @click.stop="handleDetail(row)"
              >Chi tiết
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AbsentLetterTable',
  components: {},
  props: {
    items: {type: Array, default: () => []},
    loading: {type: Boolean, default: false},
  },
  data() {
    return {
      status: {
        "PENDING": "Đang chờ",
        "APPROVED": "Đã duyệt",
        "REJECTED": "Từ chối"
      },

      // Thêm mảng quản lý các dòng đang mở rộng nội dung
      expandedRows: []
    }
  },
  methods: {
    getStatus(row) {
      return this.status[row.status];
    },
    // Hàm xử lý đóng mở dòng
    toggleExpand(row) {
      const rowId = row.id || row.nameStudent;
      const index = this.expandedRows.indexOf(rowId);
      if (index > -1) {
        this.expandedRows.splice(index, 1); // Đã mở thì đóng lại
      } else {
        this.expandedRows.push(rowId); // Chưa mở thì thêm vào mảng
      }
    },
    handleDetail(row) {
      console.log("click")
      this.$emit('detail', row.id);
    },
    handleApproved(row) {
      this.$emit("approve", row);
    },

    handleDelete(row) {
      this.$emit("delete", row);
    },

    handleSelectionChange(values) {
      this.$emit("selection-multi", values);
    }

  }
}
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-table.scss";

.attendance-table-container {
  background-color: #ffffff;
}

// ─── THIẾT KẾ BẢNG ĐIỂM DANH HIỆN ĐẠI (MÀU XANH DƯƠNG GỐC) ───────────
.custom-attendance-table {
  border-radius: 10px !important;
  overflow: hidden;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 4px 16px rgba(51, 65, 85, 0.04);

  // Style Header tầng 1
  /deep/ th.el-table__cell {
    background-color: #6a96d6 !important;
    color: #ffffff !important;
    font-weight: 600;
    padding: 8px 0;
    border-right: 1px solid #e2e8f0 !important;
    font-size: 13px;

    // Style Header tầng con
    &.is-leaf {
      background-color: #6a96d6 !important;
      border-bottom: 1px solid #5a85c2 !important;
      font-size: 12px;
      padding: 6px 0;
    }
  }

  // Hiệu ứng Hover dòng sáng nhẹ xanh dương nhẹ nhàng
  /deep/ tr.el-table__row {
    &:hover > td.el-table__cell {
      background-color: #f0f7ff !important;
    }
  }

  /deep/ td.el-table__cell {
    padding: 8px 0;
    border-bottom: 1px solid #f1f5f9;
    border-right: 1px solid #f1f5f9;
    background-color: #fff;
  }
}

// ─── ĐỊNH DẠNG TEXT TRÊN HEADER ─────────────────────────────────────
.second-title {
  display: inline-block;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.02em;
  color: #ffffff;
}

.header-checkbox-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
}

// ─── COMPONENT Ô DỮ LIỆU CELLS ──────────────────────────────────────
.student-profile-cell {
  padding-left: 8px;
  display: flex;
  align-items: center;
}

.student-name-text {
  color: #1e293b;
  font-size: 14px;
}

.status-cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-disabled {
  color: #cbd5e1;
  font-weight: bold;
}

// Thiết kế TimePicker cân đối ô lưới
.custom-time-picker {
  width: 92% !important;

  /deep/ .el-input__inner {
    padding-left: 24px !important;
    padding-right: 4px !important;
    border-radius: 6px;
    border-color: #cbd5e1;
    font-family: monospace;
    font-size: 12px;
    height: 28px !important;
    line-height: 28px !important;

    &:focus {
      border-color: #78a5e7 !important;
    }
  }

  /deep/ .el-input__icon {
    line-height: 28px !important;
  }
}

// Badge hiển thị số phút đi muộn / về muộn
.badge-minute {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;

  &--late {
    background-color: #fff7ed;
    color: #ea580c;
    border: 1px solid #ffedd5;
  }

  &--pickup {
    background-color: #fdf2f8;
    color: #db2777;
    border: 1px solid #fce7f3;
  }
}

// ─── ĐỒNG BỘ NÚT ĐIỀU KHIỂN HÀNG HOÀN THIỆN ─────────────────────────
.action-buttons-wrapper {
  display: flex;
  gap: 6px;
  justify-content: center;
  align-items: center;
  padding: 0 4px;
}

.row-action-btn {
  padding: 6px 10px !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  border-radius: 6px !important;
  transition: all 0.15s ease;
  margin: 0 !important;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &.btn-save {
    background-color: #409eff !important;
    border-color: #409eff !important;
    color: #ffffff !important;

    &:hover:not(.is-disabled) {
      background-color: #1d82e6 !important;
      border-color: #1d82e6 !important;
    }

    &.is-disabled {
      background-color: #f3f4f6 !important;
      border-color: #e5e7eb !important;
      color: #9ca3af !important;
    }
  }

  &.btn-edit {
    background-color: #67C23A !important;
    border-color: #67C23A !important;
    color: #ffffff !important;

    &:hover {
      background-color: #529b2e !important;
      border-color: #529b2e !important;
    }

    &.is-disabled {
      background-color: #f3f4f6 !important;
      border-color: #e5e7eb !important;
      color: #9ca3af !important;
    }
  }

  &.btn-cancel {
    background-color: #c54545 !important;
    border-color: #c54545 !important;
    color: #ffffff !important;

    &:hover {
      background-color: #c61e1e !important;
      border-color: #c61e1e !important;
    }

    &.is-disabled {
      background-color: #f3f4f6 !important;
      border-color: #e5e7eb !important;
      color: #9ca3af !important;
    }
  }

  &.btn-ai {
    background-color: #ffffff !important;
    border: 1px solid #dcdfe6 !important;
    color: #409eff !important;

    &:hover {
      background-color: #ecf5ff !important;
      border-color: #409eff !important;
    }
  }
}

// ─── XỬ LÝ GIỚI HẠN DÒNG CỘT NỘI DUNG ──────────────────────────────────
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.content-text {
  font-size: 13px;
  line-height: 1.5;
  color: #334155;
  word-break: break-word;
  transition: all 0.3s ease;

  // Khi đang ở trạng thái thu gọn: Giới hạn tối đa 3 dòng
  &.is-collapsed {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.toggle-content-btn {
  color: #409eff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  display: inline-block;
  margin-top: 2px;

  &:hover {
    color: #1d82e6;
    text-decoration: underline;
  }
}

// ─── BADGE TRẠNG THÁI MÀU SẮC ────────────────────────────────────────
.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border-radius: 20px; // Bo tròn dạng viên thuốc tạo cảm giác hiện đại
  font-size: 12px;
  font-weight: 600;
  min-width: 64px;
  text-align: center;
  border: 1px solid transparent;

  // Trạng thái: Đang chờ (Màu vàng/cam ấm áp)
  &--pending {
    background-color: #fef3c7;
    color: #d97706;
    border-color: #fde68a;
  }

  // Trạng thái: Đã duyệt (Màu xanh lá cây)
  &--approved {
    background-color: #dcfce7;
    color: #15803d;
    border-color: #bbf7d0;
  }

  // Trạng thái: Từ chối (Màu đỏ/hồng cam)
  &--rejected {
    background-color: #fee2e2;
    color: #b91c1c;
    border-color: #fecaca;
  }
}

// ─── ĐÈ LẠI MÀU HOẠT ĐỘNG CỦA EL-CHECKBOX SANG XANH DƯƠNG ───────────
/deep/ .el-checkbox__inner {
  border-radius: 4px;
  border-color: #7a8a9c;
  width: 16px;
  height: 16px;

  &::after {
    left: 5px;
    top: 2px;
  }
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #78a5e7 !important;
  border-color: #78a5e7 !important;
}

/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #78a5e7 !important;
}
</style>